<template>
    <project-step-container
            cover-page
            prev-to="js_edit_project"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row class="first-form-initial first-form-initial-1 pb-4 mb-2">

            <JAVideo class-name-play="play-video-initial"
                :poster="{src: srcPoster, title:'Deep Customer Empathy Video'}"
                title="Deep Customer Empathy"
                :sources="videoSources"/>

            <b-col cols="8" class="mt-4 main-title-initial text-uppercase" tabindex="0">
                 {{getMessage(2 , 'empathy-map-title')}}
            </b-col>
            <b-col cols="12" class="mt-3 mb-1 sub-title-initial"  tabindex="0">
                 {{getMessage(2 , 'empathy-map-sub')}}
            </b-col>

        </b-row>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import JAVideo from "../../../core/Components/JAVideo"
    import {Steps} from "@/modules/JobShadow/Utils";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "DeepCustomerEmpathy2",
        components: {ProjectStepContainer, JAVideo},
        data(){
            return{
                step:Steps.FORM_DEEP_CUSTOMER
            }
        },
        computed: {
            srcPoster() {
                if (this.isJACareerEntrepreApp) {
                    return require('../Images/Self-Empathy_new_logo.png');
                }

                return require('../Images/Self-Empathy.jpg');
            },
            videoSources() {
                if (this.isJACareerEntrepreApp) {
                    return [
                        {
                            src: 'https://data.ja.org/s/Mj0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 1440px)'
                        },
                        {
                            src: 'https://data.ja.org/s/MT0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 960px)'
                        },
                        {
                            src: 'https://data.ja.org/s/MD0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 720px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Lz0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 480px)'
                        },
                        {
                            src: 'https://data.ja.org/s/Lj0AAA',
                            type: 'video/mp4',
                            media: '(min-width: 360px)'
                        },
                        {
                            src: 'https://data.ja.org/s/LT0AAA',
                            type: 'video/mp4',
                        },

                    ]
                }

               return [{
                   src: 'https://jad4dmedia-usso.streaming.media.azure.net/88c62564-e62a-4301-a8d2-2e9f59162569/Step_2_Self_Empathy.ism/manifest',
                   type: 'application/vnd.ms-sstr+xml'
               }];
            }
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_deep_customer_empathy_3', params: {index}})
            }
        }
    }

</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .img-preview
        padding-bottom 75% !important
    .subtitle
        font font-sourcesans-bold
        font-size 14px
    .main-title-initial
        color black
    .sub-title-initial
        color black
</style>
